/**
 * Environment variable accessor that works in both Vite (import.meta.env)
 * and Jest (process.env) contexts.
 *
 * Vite replaces `import.meta.env.VITE_*` at build time, so at runtime
 * in production these become string literals. In Jest (CJS), `import.meta`
 * is not available, so we fall back to `process.env`.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
let viteEnv: Record<string, string> = {};

try {
  // This block is compiled away by Vite during build.
  // In Jest, the `new Function` trick avoids a CJS parse-time error.
  viteEnv = new Function('return typeof import.meta !== "undefined" ? import.meta.env || {} : {}')();
} catch {
  // Not running in an ESM context (e.g. Jest CJS) — fall through
}

function get(key: string, fallback = ''): string {
  // Vite env vars (VITE_*)
  if (viteEnv[key] !== undefined && viteEnv[key] !== '') return viteEnv[key];
  // process.env fallback (CI, Jest, SSR)
  if (typeof process !== 'undefined' && process.env?.[key]) return process.env[key]!;
  return fallback;
}

export const env = {
  API_ENDPOINT: get('VITE_API_ENDPOINT', 'https://lumina-app-api.dev.careervitae.app/v1'),
  API_KEY: get('VITE_API_KEY', ''),
  COGNITO_REGION: get('VITE_COGNITO_REGION', 'ap-southeast-2'),
  COGNITO_USER_POOL_ID: get('VITE_COGNITO_USER_POOL_ID', ''),
  COGNITO_CLIENT_ID: get('VITE_COGNITO_CLIENT_ID', ''),
} as const;
